const CALENDAR_MIN_DATE = new Date('1900-01-01');
const CALENDAR_MAX_DATE = new Date('2100-01-01');
export { CALENDAR_MAX_DATE, CALENDAR_MIN_DATE };
